import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  CssBaseline,
} from '@mui/material';
//import MapComponentGoogle from './Components/MapComponentGoogle';
import MenuIcon from '@mui/icons-material/Menu';
import MapComponentReactLeaflet from './Components/MapComponentReactLeaflet';
import AboutUs from './Components/AboutUs';
import Contact from './Components/Contact';
import AddNewLocationRequest from './Components/AddNewLocationRequest';
import PendingClientRequests from './Components/PendingClientRequests';
import Articles from './Components/Articles';
import ArticlesManagement from './Components/ArticlesManagement';

function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
        return;
      }
      setDrawerOpen(open);
    };

  const menuItems = [
    { text: 'Home', onClick: () => navigate('/') },
    { text: 'Add a Kid-Friendly Place', onClick: () => {
            setDrawerOpen(false);
            navigate('/addnewlocationrequest'); }
    },
    // { text: 'Pending Requests', onClick: () => {
    //     setDrawerOpen(false);
    //     navigate('/pendingclientrequests'); }
    // },
    { text: 'About Us', onClick: () => {
         setDrawerOpen(false);
         navigate('/about'); }
    },
    { text: 'Contact', onClick: () => {
            setDrawerOpen(false);
            navigate('/contact'); } },
        { text: 'Articles', onClick: () => {
          setDrawerOpen(false);
          navigate('/articles'); } },
  ];

  return (
    <div className="App">
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          {/* Hamburger Menu Icon */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Friendly for Kids
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        <List
          sx={{ width: 250 }}
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          {menuItems.map((item, index) => (
            <ListItem key={index} onClick={item.onClick} component="li">
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>  

        <Routes>
            <Route path="/" element={<MapComponentReactLeaflet />} />
            <Route path="/addnewlocationrequest" element={<AddNewLocationRequest />} />
          <Route path="/pendingclientrequests" element={<PendingClientRequests />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articlesmanagement" element={<ArticlesManagement />} />
        </Routes>

      {/* <Container>
        <Box my={2}> */}
          {/* <main className="map-container">
            <MapComponentReactLeaflet />
          </main> */}
        {/* </Box>
      </Container> */}
    </div>
  );
}

export default App;
